<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="alert alert-warning text-center" v-if="assistant.status === 1">
          Este perfil está aguardando moderação.
          <div class="admin-buttons-h mt-3">
            <a class="btn bg-success" @click="approveAssistant">Aprovar perfil</a>
            <a class="btn btn-cancel" @click="rejectAssistant">Reprovar perfil</a>
          </div>
        </div>
        <div class="alert alert-success text-center" v-else-if="assistant.status === 2">
          Este perfil está ativo.
          <div class="admin-buttons-h mt-3">
            <a class="btn btn-cancel" @click="inactivateAssistant">Desativar perfil</a>
          </div>
        </div>
        <div class="alert alert-danger text-center" v-else-if="assistant.status === 3">
          Este perfil está desativado.
          <div class="admin-buttons-h mt-3">
            <a class="btn bg-success" @click="activateAssistant">Ativar perfil</a>
          </div>
        </div>

        <div class="element">
          <div class="freelancer_profile">
            <div class="row">
              <div class="col-lg-12">
                <div class="talent_profile" v-if="assistant !== null">
                  <div class="talent-info">
                    <div class="freelancer_info">
                      <div class="freelancer">
                        <img
                          class="freelancer_img"
                          :src="getImageURL(assistant.picture)"
                          v-if="assistant.picture"
                          alt=""
                        />
                        <img class="freelancer_img empty-image" v-else alt="" />

                        <div class="info">
                          <div>
                            <a>
                              <h2>
                                {{ assistant.name }}
                              </h2>
                            </a>
                            <p>{{ assistant.title }}</p>
                          </div>
                          <div class="down-icons-list">
                            <div
                              class="ex_icon"
                              v-if="assistant.cert_av || assistant.cert_ap"
                            >
                              <span v-if="assistant.cert_av" class="cert_av"
                                ><i class="fa-solid fa-laptop icons"></i
                              ></span>
                              <span v-if="assistant.cert_ap" class="cert_ap"
                                ><i class="fa-solid fa-star icons"></i
                              ></span>
                              <!-- <span
                                  ><i class="fa-solid fa-trophy icons"></i
                                ></span> -->
                            </div>

                            <div class="star">
                              <i
                                :class="star.class"
                                class="icons"
                                v-for="star in getRatingStars(assistant.feedback_rating)"
                                :key="star.id"
                              ></i>
                              <span class="rating">
                                ({{ assistant.feedback_rating.toFixed(2) }})</span
                              >
                            </div>
                          </div>
                          <p class="country">{{ assistant.location }}</p>
                        </div>
                      </div>
                      <div>
                        <a class="btn" @click="editAssistant()"
                          ><i class="fa fa-pencil" style="padding-right: 5px"></i> Editar
                          perfil</a
                        ><br />

                        <!-- <a
                          class="btn"
                          @click="sendIntroAvCertificate()"
                          style="display: inline-block; margin-top: 1rem"
                          ><i class="fa fa-certificate" style="padding-right: 5px"></i>
                          Emitir Certificado Gratuito
                        </a> -->

                        <a
                          class="btn"
                          @click="sendPrograma30Certificate()"
                          style="display: inline-block; margin-top: 1rem"
                          ><i class="fa fa-certificate" style="padding-right: 5px"></i>
                          Emitir Certificado do Programa 30 Dias
                        </a>

                      </div>
                    </div>
                  </div>
                  <div class="keywords-group">
                    <div class="ky_btn" v-if="assistant.area_ap">Assistência Pessoal</div>
                    <div class="ky_btn" v-if="assistant.area_ae">
                      Secretariado Executivo
                    </div>
                    <div class="ky_btn" v-if="assistant.area_sa">
                      Suporte Administrativo
                    </div>
                    <div class="ky_btn" v-if="assistant.area_sr">Secretariado remoto</div>
                    <div class="ky_btn" v-if="assistant.area_si">
                      Suporte para Infoprodutores
                    </div>
                    <div class="ky_btn" v-if="assistant.area_ed">Entrada de dados</div>
                  </div>
                  <p class="mt-4 break-line break-all">{{ assistant.description }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row seller_review">
            <div class="col-lg-12">
              <div class="post_project user mt-5">
                <div class="nav">
                  <h1>Reviews for this seller</h1>
                  <h1 class="ratting_number">
                    <svg
                      class="svg-inline--fa fa-star icons"
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="star"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                      data-fa-i2svg=""
                    >
                      <path
                        fill="currentColor"
                        d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                      ></path></svg
                    >(550)
                  </h1>
                </div>
                <div class="proposals-list">
                  <div class="proposal">
                    <div class="user">
                      <div class="freelancer-img">
                        <img src="assets/img/assistant_img.png" alt="" />
                      </div>
                      <div class="proposal-info">
                        <p class="name">Name Here</p>
                        <div class="ratting mt-1">
                          <p class="star">
                            <svg
                              class="svg-inline--fa fa-star icons"
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="fas"
                              data-icon="star"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                              ></path></svg
                            >
                            (5.0)
                          </p>
                          <p>
                            <img src="assets/img/country/BD_Flag.png" alt="" />
                            Bangladesh
                          </p>
                        </div>
                        <p class="mt-2">Highly skilled and talented.</p>
                      </div>
                    </div>
                    <div class="day">
                      <p>Published 1 week ago</p>
                    </div>
                  </div>
                  <div class="proposal">
                    <div class="user">
                      <div class="freelancer-img">
                        <img src="assets/img/assistant_img.png" alt="" />
                      </div>
                      <div class="proposal-info">
                        <p class="name">Name Here</p>
                        <div class="ratting mt-1">
                          <p class="star">
                            <svg
                              class="svg-inline--fa fa-star icons"
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="fas"
                              data-icon="star"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                              ></path></svg
                            >
                            (5.0)
                          </p>
                          <p>
                            <img src="assets/img/country/BD_Flag.png" alt="" />
                            Bangladesh
                          </p>
                        </div>
                        <p class="mt-2">Highly skilled and talented.</p>
                      </div>
                    </div>
                    <div class="day">
                      <p>Published 1 week ago</p>
                    </div>
                  </div>
                  <div class="proposal">
                    <div class="user">
                      <div class="freelancer-img">
                        <img src="assets/img/assistant_img.png" alt="" />
                      </div>
                      <div class="proposal-info">
                        <p class="name">Name Here</p>
                        <div class="ratting mt-1">
                          <p class="star">
                            <svg
                              class="svg-inline--fa fa-star icons"
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="fas"
                              data-icon="star"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 576 512"
                              data-fa-i2svg=""
                            >
                              <path
                                fill="currentColor"
                                d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                              ></path></svg
                            >
                            (5.0)
                          </p>
                          <p>
                            <img src="assets/img/country/BD_Flag.png" alt="" />
                            Bangladesh
                          </p>
                        </div>
                        <p class="mt-2">Highly skilled and talented.</p>
                      </div>
                    </div>
                    <div class="day">
                      <p>Published 1 week ago</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Assinatura</h1>
            <div>
              <a
                class="btn btn-small"
                @click="addSubscription()"
                v-if="assistant.plan !== 'Starter'"
                ><i class="fa fa-plus" style="padding-right: 5px"></i> Liberar acesso</a
              >
              &nbsp;
              <a class="btn btn-small" @click="syncSubscription()"
                ><i class="fa fa-gear" style="padding-right: 5px"></i> Sincronizar</a
              >
              &nbsp;
              <a
                class="btn btn-small btn-cancel"
                @click="cancelSubscription()"
                v-if="subscription && !subscription.expired"
                ><i class="fa fa-times" style="padding-right: 5px"></i> Cancelar</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div>
              <strong>Plano:</strong>
              <span
                class="btn btn-small"
                :class="getPlanClass(assistant.plan, subscription)"
                style="margin-left: 5px; cursor: default"
              >
                {{
                  subscription && subscription.expired
                    ? `${subscription.plan} - EXPIRADO`
                    : assistant.plan
                }}</span
              ><br />

              <div v-if="subscription">
                <div style="line-height: 1" class="mt-3">
                  <strong>Data de início:</strong>
                  {{ formatTimestamp(subscription.start_timestamp) }}
                </div>
                <div style="line-height: 1" class="mt-2">
                  <strong>Data de expiração:</strong>
                  {{ formatTimestamp(subscription.end_timestamp) }}
                </div>

                <div style="line-height: 1" class="mt-2">
                  <strong>ID do pedido/gateway:</strong>
                  {{ subscription.order_id }} / {{ subscription.gateway }}
                </div>

                <div v-if="this.subscription.utm_params" class="mt-0">
                  <!-- <div style="line-height: 1">
                    <strong>Canal de aquisição:</strong>
                    {{ formatUTMParams(this.subscription.utm_params).first }}
                  </div> -->
                  <div style="line-height: 1" class="mt-2">
                    <strong>Canal da venda:</strong>
                    {{ formatUTMParams(this.subscription.utm_params).last }}
                  </div>
                </div>
                <div style="line-height: 1" class="mt-3">
                  <strong>Renovação automática:</strong>

                  <span
                    class="btn btn-small"
                    :class="{
                      'bg-success': subscription.auto_renew,
                      'bg-danger': !subscription.auto_renew,
                    }"
                    style="margin-left: 5px; cursor: default"
                  >
                    {{ subscription.auto_renew ? `Ativada` : "Desativada" }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Formação Assistente Virtual</h1>
            <div>
              <a
                class="btn btn-small"
                @click="addCourse('form-av')"
                v-if="this.formAvCourse === null || !this.formAvCourse.available"
                ><i class="fa fa-plus" style="padding-right: 5px"></i> Liberar acesso</a
              >
              &nbsp;
              <a class="btn btn-small" @click="syncOrders()"
                ><i class="fa fa-gear" style="padding-right: 5px"></i> Sincronizar</a
              >
              &nbsp;
              <a
                class="btn btn-small btn-cancel"
                @click="cancelFormAv()"
                v-if="this.formAvCourse !== null && this.formAvCourse.available"
                ><i class="fa fa-times" style="padding-right: 5px"></i> Cancelar acesso</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div>
              <strong> Acesso:</strong>
              <span
                class="btn btn-small"
                :class="
                  this.formAvCourse !== null && this.formAvCourse.available
                    ? 'bg-success'
                    : 'bg-danger'
                "
                style="margin-left: 5px; cursor: default"
                >{{
                  this.formAvCourse !== null
                    ? this.formAvCourse.available
                      ? "Liberado"
                      : "Expirado"
                    : "Não liberado"
                }}</span
              ><br />
              <div v-if="this.formAvCourse !== null">
                <div style="line-height: 1" class="mt-3">
                  <strong>Data de início:</strong>
                  {{ formatTimestamp(this.formAvCourse.start_timestamp) }}
                </div>
                <div style="line-height: 1" class="mt-2">
                  <strong>Data de expiração:</strong>
                  {{ formatTimestamp(this.formAvCourse.end_timestamp) }}
                </div>

                <div style="line-height: 1" class="mt-2">
                  <strong>ID do pedido/gateway:</strong>
                  {{ this.formAvCourse.order_id }} / {{ this.formAvCourse.gateway }}
                </div>

                <div v-if="this.formAvCourse.utm_params" class="mt-0">
                  <!-- <div style="line-height: 1">
                    <strong>Canal de aquisição:</strong>
                    {{ formatUTMParams(this.formAvCourse.utm_params).first }}
                  </div> -->
                  <div style="line-height: 1" class="mt-2">
                    <strong>Canal da venda:</strong>
                    {{ formatUTMParams(this.formAvCourse.utm_params).last }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Formação AExpert</h1>
            <div>
              <a
                class="btn btn-small"
                @click="addCourse('form-ap')"
                v-if="this.formApCourse === null || !this.formApCourse.available"
                ><i class="fa fa-plus" style="padding-right: 5px"></i> Liberar acesso</a
              >
              &nbsp;
              <a class="btn btn-small" @click="syncOrders()"
                ><i class="fa fa-gear" style="padding-right: 5px"></i> Sincronizar</a
              >
              &nbsp;
              <a
                class="btn btn-small btn-cancel"
                @click="cancelFormAp()"
                v-if="this.formApCourse !== null && this.formApCourse.available"
                ><i class="fa fa-times" style="padding-right: 5px"></i> Cancelar acesso</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div>
              <strong>Acesso:</strong>
              <span
                class="btn btn-small"
                :class="
                  this.formApCourse !== null && this.formApCourse.available
                    ? 'bg-success'
                    : 'bg-danger'
                "
                style="margin-left: 5px; cursor: default"
                >{{
                  this.formApCourse !== null
                    ? this.formApCourse.available
                      ? "Liberado"
                      : "Expirado"
                    : "Não liberado"
                }}</span
              ><br />
              <div v-if="this.formApCourse !== null">
                <div style="line-height: 1" class="mt-3">
                  <strong>Data de início:</strong>
                  {{ formatTimestamp(this.formApCourse.start_timestamp) }}
                </div>
                <div style="line-height: 1" class="mt-2">
                  <strong>Data de expiração:</strong>
                  {{ formatTimestamp(this.formApCourse.end_timestamp) }}
                </div>

                <div style="line-height: 1" class="mt-2">
                  <strong>ID do pedido/gateway:</strong>
                  {{ this.formApCourse.order_id }} / {{ this.formApCourse.gateway }}
                </div>

                <div v-if="this.formApCourse.utm_params" class="mt-0">
                  <!-- <div style="line-height: 1" class="mt-2">
                    <strong>Canal de aquisição:</strong>
                    {{ formatUTMParams(this.formApCourse.utm_params).first }}
                  </div> -->
                  <div style="line-height: 1" class="mt-2">
                    <strong>Canal da venda: </strong>
                    {{ formatUTMParams(this.formApCourse.utm_params).last }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Método Virtap de Conquistar Clientes</h1>
            <div>
              <a
                class="btn btn-small"
                @click="addCourse('mtd-virtap')"
                v-if="
                  this.metodoVirtapCourse === null || !this.metodoVirtapCourse.available
                "
                ><i class="fa fa-plus" style="padding-right: 5px"></i> Liberar acesso</a
              >
              &nbsp;
              <a class="btn btn-small" @click="syncOrders()"
                ><i class="fa fa-gear" style="padding-right: 5px"></i> Sincronizar</a
              >
              &nbsp;
              <a
                class="btn btn-small btn-cancel"
                @click="cancelMetodoVirtap()"
                v-if="
                  this.metodoVirtapCourse !== null && this.metodoVirtapCourse.available
                "
                ><i class="fa fa-times" style="padding-right: 5px"></i> Cancelar acesso</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div>
              <strong>Acesso:</strong>
              <span
                class="btn btn-small"
                :class="
                  this.metodoVirtapCourse !== null && this.metodoVirtapCourse.available
                    ? 'bg-success'
                    : 'bg-danger'
                "
                style="margin-left: 5px; cursor: default"
                >{{
                  this.metodoVirtapCourse !== null
                    ? this.metodoVirtapCourse.available
                      ? "Liberado"
                      : "Expirado"
                    : "Não liberado"
                }}</span
              ><br />
              <div v-if="this.metodoVirtapCourse !== null">
                <div style="line-height: 1" class="mt-3">
                  <strong>Data de início:</strong>
                  {{ formatTimestamp(this.metodoVirtapCourse.start_timestamp) }}
                </div>
                <div style="line-height: 1" class="mt-2">
                  <strong>Data de expiração:</strong>
                  {{ formatTimestamp(this.metodoVirtapCourse.end_timestamp) }}
                </div>

                <div style="line-height: 1" class="mt-2">
                  <strong>ID do pedido/gateway:</strong>
                  {{ this.metodoVirtapCourse.order_id }} /
                  {{ this.metodoVirtapCourse.gateway }}
                </div>

                <div v-if="this.metodoVirtapCourse.utm_params" class="mt-0">
                  <!-- <div style="line-height: 1" class="mt-2">
                    <strong>Canal de aquisição:</strong>
                    {{ formatUTMParams(this.formApCourse.utm_params).first }}
                  </div> -->
                  <div style="line-height: 1" class="mt-2">
                    <strong>Canal da venda: </strong>
                    {{ formatUTMParams(this.metodoVirtapCourse.utm_params).last }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Do Zero ao Primeiro Cliente como AV</h1>
            <div>
              <a
                class="btn btn-small"
                @click="addCourse('cliente-av')"
                v-if="this.clienteAvCourse === null || !this.clienteAvCourse.available"
                ><i class="fa fa-plus" style="padding-right: 5px"></i> Liberar acesso</a
              >
              &nbsp;
              <a class="btn btn-small" @click="syncOrders()"
                ><i class="fa fa-gear" style="padding-right: 5px"></i> Sincronizar</a
              >
              &nbsp;
              <a
                class="btn btn-small btn-cancel"
                @click="cancelClienteAv()"
                v-if="this.clienteAvCourse !== null && this.clienteAvCourse.available"
                ><i class="fa fa-times" style="padding-right: 5px"></i> Cancelar acesso</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div>
              <strong>Acesso:</strong>
              <span
                class="btn btn-small"
                :class="
                  this.clienteAvCourse !== null && this.clienteAvCourse.available
                    ? 'bg-success'
                    : 'bg-danger'
                "
                style="margin-left: 5px; cursor: default"
                >{{
                  this.clienteAvCourse !== null
                    ? this.clienteAvCourse.available
                      ? "Liberado"
                      : "Expirado"
                    : "Não liberado"
                }}</span
              ><br />
              <div v-if="this.clienteAvCourse !== null">
                <div style="line-height: 1" class="mt-3">
                  <strong>Data de início:</strong>
                  {{ formatTimestamp(this.clienteAvCourse.start_timestamp) }}
                </div>
                <div style="line-height: 1" class="mt-2">
                  <strong>Data de expiração:</strong>
                  {{ formatTimestamp(this.clienteAvCourse.end_timestamp) }}
                </div>

                <div style="line-height: 1" class="mt-2">
                  <strong>ID do pedido/gateway:</strong>
                  {{ this.clienteAvCourse.order_id }} /
                  {{ this.clienteAvCourse.gateway }}
                </div>

                <div v-if="this.clienteAvCourse.utm_params" class="mt-0">
                  <!-- <div style="line-height: 1" class="mt-2">
                    <strong>Canal de aquisição:</strong>
                    {{ formatUTMParams(this.formApCourse.utm_params).first }}
                  </div> -->
                  <div style="line-height: 1" class="mt-2">
                    <strong>Canal da venda: </strong>
                    {{ formatUTMParams(this.clienteAvCourse.utm_params).last }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <div class="tab">
            <h1>Dados de faturamento</h1>
            <div>
              <a class="btn btn-small" @click="editBillingDetails()"
                ><i class="fa fa-pencil" style="padding-right: 5px"></i> Editar</a
              >
            </div>
          </div>
          <div class="description-part section plan">
            <div v-if="billingDetails">
              <p>Nome: {{ billingDetails.name }}</p>
              <p>CPF/CNPJ: {{ formatCPFCNPJ(billingDetails.cpf_cnpj) }}</p>
            </div>
            <div v-else class="text-muted">
              <p>Sem dados</p>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" v-if="this.assistant.utm_params">
          <div class="tab">
            <h1>Origem</h1>
          </div>
          <div class="description-part section plan">
            <div style="line-height: 1">
              <strong>Canal de aquisição:</strong>
              {{ formatUTMParams(this.assistant.utm_params).first }}
            </div>
            <div style="line-height: 1" class="mt-2">
              <strong>Canal de cadastro:</strong>
              {{ formatUTMParams(this.assistant.utm_params).last }}
            </div>
          </div>
        </div>

        <div style="margin-top: 30px" v-if="this.assistant.profile">
          <div class="tab">
            <h1>Profile</h1>
          </div>
          <div class="description-part section plan">
            <div
              v-for="profileKey in this.orderedProfileKeys"
              :key="profileKey"
              style="line-height: 1; margin-bottom: 8px"
            >
              <div v-if="this.assistant.profile && this.assistant.profile[profileKey]">
                <strong>{{ this.profileLabels[profileKey] || profileKey }}:</strong>
                {{ formatProfileValue(profileKey, this.assistant.profile?.[profileKey]) }}
              </div>
            </div>
          </div>
        </div>

        <div class="seller_review">
          <div class="tab">
            <h1>
              Avaliações
              <span class="text-muted fs-6">({{ reviews.length }})</span>
            </h1>
          </div>
          <div class="section" style="padding: 0" v-if="reviews.length > 0">
            <div
              class="proposals-list"
              style="height: auto; max-height: 100%; padding-bottom: 0"
            >
              <div class="proposal-container">
                <div
                  class="proposal"
                  style="padding: 20px; cursor: pointer"
                  v-for="review in reviews"
                  :key="review.project_id"
                  @click="showProposal(assistant.id, review.project_id)"
                >
                  <div class="proposal-info">
                    <p class="name break-all" style="font-size: 14.2px">
                      {{ review.title }}
                    </p>
                    <p
                      class="project"
                      style="
                        font-style: italic;
                        font-size: 9pt;
                        display: flex;
                        gap: 5px;
                        flex-wrap: wrap;
                        align-items: center;
                      "
                      @click="showProposal(assistant.id, review.project_id)"
                    >
                      <img
                        class="freelancer_img"
                        style="width: 50px; height: 50px"
                        :src="getImageURL(review.picture)"
                        v-if="review.picture"
                      />
                      <img class="empty-image" style="width: 50px; height: 50px" v-else />
                      <span class="break-all">{{ review.name }}</span>
                    </p>
                    <p class="project mt-1" style="margin-left: -5px">
                      <i
                        :class="star.class"
                        class="icons"
                        v-for="star in getRatingStars(review.assistant_rating)"
                        :key="star.id"
                        style="font-size: 15px"
                      ></i>
                      <span class="rating">
                        ({{ review.assistant_rating.toFixed(2) }})</span
                      >
                    </p>
                    <p class="date">{{ formatElapsedTime(review.release_timestamp) }}</p>
                    <p class="project mt-2 break-all break-line">
                      {{ review.assistant_comment }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="section text-center" v-else>
            <h2 class="light p-2">
              <div
                class="d-flex"
                style="
                  align-items: center;
                  gap: 5px;
                  flex-wrap: wrap;
                  justify-content: center;
                "
              >
                <i class="fa-regular fa-star" style="font-size: 30px"></i>
                <span>Nenhuma avaliação</span>
              </div>
            </h2>
          </div>
        </div>

        <p class="mt-4 text-muted fw-bold">Propostas</p>

        <div v-if="!assistant.proposals || assistant.proposals.length === 0">
          <p>Nenhuma proposta foi enviada por este perfil de assistente.</p>
        </div>
        <div class="active-project" style="padding: 0" v-else>
          <a
            class="card"
            style="position: static"
            v-for="proposal in assistant.proposals"
            :key="proposal.project_id"
            :href="'/proposta/' + assistant.id + '/' + proposal.project_id"
          >
            <div class="name">
              <p>
                Assistente <br />
                <span>{{ assistant.name }}</span>
              </p>
            </div>
            <div class="date">
              <p>
                Data de registro <br />
                <span>{{ formatTimestamp(proposal.registration_timestamp) }}</span>
              </p>
            </div>
            <div class="count">
              <p>
                Tem feedback? <br />
                <span :class="{ 'text-success': proposal.assistant_rating }">{{
                  proposal.assistant_rating ? "Sim" : "Não"
                }}</span>
              </p>
            </div>
            <div class="status">
              <p>
                Status <br />
                <span :class="getTextStatusClass(proposal.status)">
                  {{ formatAssistantStatus(proposal.status) }}</span
                >
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AdminManager from "../../../js/services/admin.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

function updateAssistant($ctx, response) {
  $ctx.assistant = response.assistant;
  $ctx.subscription = response.subscription;
  $ctx.courses = response.courses;
  $ctx.billingDetails = response.billingDetails;
  $ctx.reviews = response.reviews;
}

export default {
  components: { SideBar, TopBar },

  created() {
    this.$store.commit("setActiveSection", "AssistantPage");
    this.loadAssistantProfile();
  },

  data() {
    return {
      assistant: null,
      billingDetails: null,
      courses: null,
      subscription: null,
      profileLabels: {
        area: "Área",
        flow: "Estágio",
        income: "Renda",
        origin: "Origem",
        situation: "Situação",
        motivation: "Motivação",
        objection: "Obstáculo",
        intent: "Intenção",
        investment: "Investimento"
      },
      orderedProfileKeys: [
        "flow",
        "origin",
        "situation",
        "area",
        "income",
        "motivation",
        "objection",
        "intent",
        "investment"
      ],
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    formAvCourse() {
      if (this.courses) {
        let course = this.courses.find((c) => c.id === "form-av");
        if (course && course.start_timestamp) {
          return course;
        }
      }
      return null;
    },
    formApCourse() {
      if (this.courses) {
        let course = this.courses.find((c) => c.id === "form-ap");
        if (course && course.start_timestamp) {
          return course;
        }
      }
      return null;
    },
    metodoVirtapCourse() {
      if (this.courses) {
        let course = this.courses.find((c) => c.id === "mtd-virtap");
        if (course && course.start_timestamp) {
          return course;
        }
      }
      return null;
    },
    clienteAvCourse() {
      if (this.courses) {
        let course = this.courses.find((c) => c.id === "cliente-av");
        if (course && course.start_timestamp) {
          return course;
        }
      }
      return null;
    },
  },

  methods: {
    async loadAssistantProfile() {
      this.$store.commit("setLoading", true);

      try {
        let response = await AdminManager.getAssistant(this.$route.params.assistantId);
        this.profile = response.profile;

        updateAssistant(this, response);
        this.$store.commit("setActiveUser", this.profile);
        this.$store.commit("setLoading", false);
      } catch (error) {
        this.handleAPIError(error, this.$route.fullPath.replace(/^\/+/, ""));
      }
    },

    editAssistant() {
      let $ctx = this;
      let $modal = $("#editAssistantModal");
      let $profileImage = $("#editAssistantProfileImg");
      let $btnRemovePhoto = $modal.find("[data-remove-photo]");
      let $name = $modal.find("[data-assistant-name]");
      let $whatsapp = $modal.find("[data-assistant-whatsapp]");
      let $title = $modal.find("[data-assistant-title]");
      let $description = $modal.find("[data-assistant-description]");
      let $chkAreas = $("#areasAtuacao");
      let $chkCerts = $("#certificacoes");

      $modal.find("#finput_assistant").val("");
      $modal.find(".item").removeClass("error");
      $name.val($ctx.assistant.name);
      $whatsapp.val($ctx.assistant.phone);
      $title.val($ctx.assistant.title);
      $description.val($ctx.assistant.description);

      $modal.find("[data-assistant-email]").val($ctx.assistant.email_address);

      $modal.find("input[type=checkbox]").prop("checked", false);

      if ($ctx.assistant.cert_av) {
        $chkCerts
          .find("input[type=checkbox][value='ASSISTENTE_VIRTUAL'")
          .prop("checked", true);
      }

      if ($ctx.assistant.cert_ap) {
        $chkCerts
          .find("input[type=checkbox][value='ASSISTENTE_PESSOAL'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_ap) {
        $chkAreas
          .find("input[type=checkbox][value='ASSISTENCIA_PESSOAL'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_ae) {
        $chkAreas
          .find("input[type=checkbox][value='SECRETARIADO_EXECUTIVO'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_sa) {
        $chkAreas
          .find("input[type=checkbox][value='SUPORTE_ADMINISTRATIVO'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_sr) {
        $chkAreas
          .find("input[type=checkbox][value='SECRETARIADO_REMOTO'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_si) {
        $modal
          .find("input[type=checkbox][value='SUPORTE_PARA_INFOPRODUTORES'")
          .prop("checked", true);
      }

      if ($ctx.assistant.area_ed) {
        $chkAreas
          .find("input[type=checkbox][value='ENTRADA_DE_DADOS'")
          .prop("checked", true);
      }

      if (this.assistant.picture) {
        $profileImage.show();
        $profileImage.attr("src", this.getImageURL(this.assistant.picture));
        $btnRemovePhoto.show();
      } else {
        $btnRemovePhoto.hide();
        $profileImage.removeAttr("src");
      }
      $profileImage.data("file", null);

      $btnRemovePhoto.off().on("click", function () {
        $btnRemovePhoto.hide();
        $profileImage.removeAttr("src");
        $profileImage.data("file", null);
        $profileImage.data("removeFile", true);
      });

      let action = async function () {
        let selectedAreas = [];
        let selectedCertifications = [];

        $chkAreas.find("input[type=checkbox]:checked").each(function (i, e) {
          selectedAreas.push($(e).attr("value"));
        });

        $chkCerts.find("input[type=checkbox]:checked").each(function (i, e) {
          selectedCertifications.push($(e).attr("value"));
        });

        let assistantDetails = {
          name: $name.val(),
          phone: $whatsapp.val(),
          title: $title.val(),
          description: $description.val(),
          expertise_areas: selectedAreas,
          certifications: selectedCertifications,
        };

        if ($profileImage.data("file")) {
          assistantDetails.picture = $profileImage.data("file");
        } else if ($profileImage.data("removeFile")) {
          assistantDetails.removePicture = true;
        }

        let hasError = false;
        $modal.find(".item").removeClass("error");

        if (assistantDetails.name.length < 10) {
          $name.closest(".item").addClass("error");
          hasError = true;
        }

        if (assistantDetails.title.length < 10) {
          $title.closest(".item").addClass("error");
          hasError = true;
        }

        if (assistantDetails.phone.length < 10) {
          $whatsapp.closest(".item").addClass("error");
          hasError = true;
        }

        if (assistantDetails.description.length < 100) {
          $description.closest(".item").addClass("error");
          hasError = true;
        }

        if (
          assistantDetails.expertise_areas.length === 0 ||
          assistantDetails.expertise_areas.length > 3
        ) {
          $chkAreas.closest(".item").addClass("error");
          hasError = true;
        }

        if (hasError) {
          return false;
        }

        let response = await AdminManager.updateAssistant(
          $ctx.assistant.id,
          assistantDetails
        );

        updateAssistant($ctx, response);
        return true;
      };

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-assistant-name]").focus();
        },
        "Salvar",
        action,
        "Perfil atualizado.",
        "Ocorreu um erro editar o perfil.\nPor favor, tente novamente."
      );
    },

    sendIntroAvCertificate() {
      window.open(
        `${Config.apiHost}/admin/send-intro-av-certificate/${this.assistant.id}`
      );
    },

    sendPrograma30Certificate() {
      window.open(
        `${Config.apiHost}/admin/send-programa-30-certificate/${this.assistant.id}`
      );
    },

    approveAssistant() {
      let $ctx = this;

      let action = async function () {
        let assistantDetails = {
          status: 2,
        };

        let response = await AdminManager.updateAssistant(
          $ctx.assistant.id,
          assistantDetails
        );

        updateAssistant($ctx, response);
        return true;
      };

      this.showConfirmation(
        "Aprovar perfil",
        "Tem certeza que deseja aprovar este perfil?",
        "Aprovar",
        action,
        "O perfil foi aprovado.",
        "Ocorreu um erro ao aprovar o perfil.\nPor favor, tente novamente."
      );
    },

    activateAssistant() {
      let $ctx = this;

      let action = async function () {
        let assistantDetails = {
          status: 2,
        };

        let response = await AdminManager.updateAssistant(
          $ctx.assistant.id,
          assistantDetails
        );

        updateAssistant($ctx, response);
        return true;
      };

      this.showConfirmation(
        "Ativar perfil",
        "Tem certeza que deseja ativar este perfil?",
        "Ativar",
        action,
        "O perfil foi ativado.",
        "Ocorreu um erro ao ativar o perfil.\nPor favor, tente novamente."
      );
    },

    rejectAssistant() {
      let $ctx = this;

      let action = async function () {
        let assistantDetails = {
          status: 3,
        };

        let response = await AdminManager.updateAssistant(
          $ctx.assistant.id,
          assistantDetails
        );

        updateAssistant($ctx, response);
        return true;
      };

      this.showConfirmation(
        "Reprovar perfil",
        "Tem certeza que deseja reprovar este perfil ?",
        "Reprovar",
        action,
        "O perfil foi reprovado.",
        "Ocorreu um erro ao reprovar este perfil.\nPor favor, tente novamente."
      );
    },

    inactivateAssistant() {
      let $ctx = this;

      let action = async function () {
        let assistantDetails = {
          status: 3,
        };

        let response = await AdminManager.updateAssistant(
          $ctx.assistant.id,
          assistantDetails
        );

        updateAssistant($ctx, response);
        return true;
      };

      this.showConfirmation(
        "Desativar perfil",
        "Tem certeza que deseja desativar este perfil?",
        "Desativar",
        action,
        "O perfil foi desativado.",
        "Ocorreu um erro ao desativar este perfil.\nPor favor, tente novamente."
      );
    },

    addSubscription() {
      let $ctx = this;
      let $modal = $("#addSubscriptionModal");

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");
        let $details = $modal.find("[data-details]");

        let subscriptionInfo = {
          orderRef: $("#order_reference").val(),
          details: $details.val(),
        };

        if (
          StringUtils.isEmpty(subscriptionInfo.details) ||
          subscriptionInfo.details.length < 10
        ) {
          $details.closest(".item").addClass("error");
          hasError = true;
        }

        if (hasError) {
          return false;
        }

        let response = await AdminManager.addSubscription(
          $ctx.assistant.id,
          subscriptionInfo
        );
        updateAssistant($ctx, response);
        return true;
      };

      $modal.find("[data-details]").val("");

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-details]").focus();
        },
        "Adicionar",
        action,
        "Assinatura criada!",
        "Ocorreu um erro adicionar a assinatura.\n Verifique os logs e tente novamente."
      );
    },

    syncSubscription() {
      let $ctx = this;

      let action = async function () {
        let result = await AdminManager.syncSubscription($ctx.assistant.id);

        if (result.issues && result.issues.length > 0) {
          console.log(result.issues);
          throw new Error("Falha ao sincronizar.");
        }

        updateAssistant($ctx, result.assistantData);
        return true;
      };

      this.showConfirmation(
        "Sincronizar assinatura",
        "Tem certeza que deseja sincronizar a assinatura?",
        "Sincronizar",
        action,
        "A assinatura foi sincronizada.",
        "Ocorreu um erro ao sincronizar a assinatura. Verifique os logs e tente novamente."
      );
    },

    addCourse(courseId) {
      let $ctx = this;
      let $modal = $("#addFormApModal");
      let title = "Liberar acesso";

      if (courseId === "form-av") {
        title = "Liberar acesso à Formação Assistente Virtual";
      } else if (courseId === "form-ap") {
        title = "Liberar acesso à Formação AExpert";
      }

      $modal.find(".modal-title").text(title);

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");
        let $details = $modal.find("[data-details]");

        let courseInfo = {
          course_id: courseId,
          details: $details.val(),
        };

        if (StringUtils.isEmpty(courseInfo.details) || courseInfo.details.length < 10) {
          $details.closest(".item").addClass("error");
          hasError = true;
        }

        if (hasError) {
          return false;
        }

        let response = await AdminManager.addAssistantCourse(
          $ctx.assistant.id,
          courseInfo
        );
        updateAssistant($ctx, response);
        return true;
      };

      $modal.find("[data-details]").val("");

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-details]").focus();
        },
        "Adicionar",
        action,
        "Acesso liberado!",
        "Ocorreu um erro adicionar o acesso.\n Verifique os logs e tente novamente."
      );
    },

    cancelFormAv() {
      let $ctx = this;
      let action = async function () {
        let response = await AdminManager.cancelOrder(
          $ctx.assistant.id,
          $ctx.formAvCourse.order_id
        );
        updateAssistant($ctx, response);
        return true;
      };

      let doCancel = function () {
        $ctx.showConfirmation(
          "Cancelar acesso",
          "Tem certeza que deseja cancelar o acesso desta assistente à Formação Assistente Virtual?",
          "Sim",
          action,
          "Acesso cancelado!",
          "Ocorreu um erro ao cancelar acesso. Verifique os logs e tente novamente.",
          "Fechar"
        );
      };

      if ($ctx.formAvCourse.gateway === "admin") {
        doCancel();
      } else {
        $ctx.showError(
          `Para cancelar este acesso, é necessário cancelar a fatura ${$ctx.formAvCourse.order_id} no gateway ${$ctx.formAvCourse.gateway}.`
        );
      }
    },

    cancelFormAp() {
      let $ctx = this;
      let action = async function () {
        let response = await AdminManager.cancelOrder(
          $ctx.assistant.id,
          $ctx.formApCourse.order_id
        );
        updateAssistant($ctx, response);
        return true;
      };

      let doCancel = function () {
        $ctx.showConfirmation(
          "Cancelar acesso",
          "Tem certeza que deseja cancelar o acesso desta assistente à Formação AExpert?",
          "Sim",
          action,
          "Acesso cancelado!",
          "Ocorreu um erro ao cancelar acesso. Verifique os logs e tente novamente.",
          "Fechar"
        );
      };

      if ($ctx.formApCourse.gateway === "admin") {
        doCancel();
      } else {
        $ctx.showError(
          `Para cancelar este acesso, é necessário cancelar a fatura ${$ctx.formApCourse.order_id} no gateway ${$ctx.formApCourse.gateway}.`
        );
      }
    },

    cancelMetodoVirtap() {
      let $ctx = this;
      let action = async function () {
        let response = await AdminManager.cancelOrder(
          $ctx.assistant.id,
          $ctx.metodoVirtapCourse.order_id
        );
        updateAssistant($ctx, response);
        return true;
      };

      let doCancel = function () {
        $ctx.showConfirmation(
          "Cancelar acesso",
          "Tem certeza que deseja cancelar o acesso desta assistente ao Método Virtap?",
          "Sim",
          action,
          "Acesso cancelado!",
          "Ocorreu um erro ao cancelar acesso. Verifique os logs e tente novamente.",
          "Fechar"
        );
      };

      if ($ctx.metodoVirtapCourse.gateway === "admin") {
        doCancel();
      } else {
        $ctx.showError(
          `Para cancelar este acesso, é necessário cancelar a fatura ${$ctx.metodoVirtapCourse.order_id} no gateway ${$ctx.metodoVirtapCourse.gateway}.`
        );
      }
    },

    cancelClienteAv() {
      let $ctx = this;
      let action = async function () {
        let response = await AdminManager.cancelOrder(
          $ctx.assistant.id,
          $ctx.clienteAvCourse.order_id
        );
        updateAssistant($ctx, response);
        return true;
      };

      let doCancel = function () {
        $ctx.showConfirmation(
          "Cancelar acesso",
          "Tem certeza que deseja cancelar o acesso desta assistente ao programa Do Zero Ao Primeiro Cliente como AV?",
          "Sim",
          action,
          "Acesso cancelado!",
          "Ocorreu um erro ao cancelar acesso. Verifique os logs e tente novamente.",
          "Fechar"
        );
      };

      if ($ctx.clienteAvCourse.gateway === "admin") {
        doCancel();
      } else {
        $ctx.showError(
          `Para cancelar este acesso, é necessário cancelar a fatura ${$ctx.clienteAvCourse.order_id} no gateway ${$ctx.clienteAvCourse.gateway}.`
        );
      }
    },
    syncOrders() {
      let $ctx = this;

      let action = async function () {
        let result = await AdminManager.syncAssistantOrders($ctx.assistant.id);
        if (result.issues && result.issues.length > 0) {
          console.log(result.issues);
          throw new Error("Falha ao sincronizar.");
        }

        updateAssistant($ctx, result.assistantData);
        return true;
      };

      this.showConfirmation(
        "Sincronizar curso",
        "Tem certeza que deseja sincronizar este curso?",
        "Sincronizar",
        action,
        "O curso foi sincronizado.",
        "Ocorreu um erro ao sincronizar o curso. Verifique os logs e tente novamente."
      );
    },

    editBillingDetails() {
      let $ctx = this;
      let $modal = $("#editBillingDetailsModal");

      $modal
        .find("[data-cpf-cnpj]")
        .val($ctx.billingDetails ? $ctx.billingDetails.cpf_cnpj : "");
      $modal.find("[data-name]").val($ctx.billingDetails ? $ctx.billingDetails.name : "");
      $modal
        .find("[data-address]")
        .val($ctx.billingDetails ? $ctx.billingDetails.address : "");
      $modal
        .find("[data-number]")
        .val($ctx.billingDetails ? $ctx.billingDetails.address_number : "");
      $modal
        .find("[data-complement]")
        .val($ctx.billingDetails ? $ctx.billingDetails.complement : "");
      $modal
        .find("[data-neighborhood]")
        .val($ctx.billingDetails ? $ctx.billingDetails.neighborhood : "");
      $modal
        .find("[data-cep]")
        .val($ctx.billingDetails ? $ctx.billingDetails.zipcode : "");
      $modal.find("[data-uf]").val($ctx.billingDetails ? $ctx.billingDetails.state : "");
      $modal
        .find("[data-phone]")
        .val($ctx.billingDetails ? $ctx.billingDetails.phone : "");

      $modal.find(".item").removeClass("error");

      if ($ctx.billingDetails) {
        $ctx.populateMunicipios($ctx.billingDetails.state, $modal.find("[data-city]"));
      } else {
        $modal.find("[data-city]").val("");
        $modal.find("[data-uf]").val("");
      }

      $modal
        .find("[data-uf]")
        .off()
        .on("change", function () {
          const ufSelecionado = $(this).val(); // Pega a UF selecionada
          $ctx.populateMunicipios(ufSelecionado, $modal.find("[data-city]")); // Chama a função para popular os municípios
        });

      $modal.find("[data-city]").val($ctx.billingDetails ? $ctx.billingDetails.city : "");

      let action = async function () {
        let hasError = false;
        $modal.find(".item").removeClass("error");

        let $name = $modal.find("[data-name]");
        let $cpf_cnpj = $modal.find("[data-cpf-cnpj]");

        let billingDetails = {
          name: $name.val(),
          cpf_cnpj: $cpf_cnpj.val().replace(/\D/g, ""),
        };

        if (!$ctx.validateCPFCNPJ(billingDetails.cpf_cnpj)) {
          $cpf_cnpj.closest(".item").addClass("error");
          hasError = true;
        }

        if (StringUtils.isEmpty(billingDetails.name) || billingDetails.name.length < 10) {
          $name.closest(".item").addClass("error");
          hasError = true;
        }

        if (hasError) {
          return false;
        }

        let result = await AdminManager.setBillingDetails(
          $ctx.assistant.id,
          billingDetails
        );

        if (result.billingDetails) {
          $ctx.billingDetails = result.billingDetails;
        } else {
          throw new Error("Falha ao atualizar dados de faturamento.");
        }

        return true;
      };

      this.showModal(
        $modal,
        function () {
          $modal.find("[data-cpf-cnpj]").focus();
        },
        "Salvar",
        action,
        "Dados atualizados.",
        "Ocorreu um erro editar os dados de faturamento.\nPor favor, tente novamente."
      );
    },

    getPlanClass(plan, subscription) {
      if (subscription && subscription.expired) {
        return "bg-danger";
      }
      if (plan === "Free") {
        return "bg-warning";
      } else {
        return "bg-success";
      }
    },

    cancelSubscription() {
      let $ctx = this;
      let action = async function () {
        let response = await AdminManager.cancelOrder(
          $ctx.assistant.id,
          $ctx.subscription.order_id
        );
        updateAssistant($ctx, response);
        return true;
      };

      let doCancel = function () {
        $ctx.showConfirmation(
          "Cancelar assinatura",
          "Tem certeza que deseja cancelar a assinatura?",
          "Sim",
          action,
          "A assinatura foi cancelada.",
          "Ocorreu um erro ao cancelar a assinatura. Verifique os logs e tente novamente.",
          "Fechar"
        );
      };

      if ($ctx.assistant.plan === "Starter") {
        $ctx.showError(
          "Para cancelar esta assinatura, é necessário fazer o cancelamento via Stripe."
        );
      } else {
        if ($ctx.subscription.gateway === "admin") {
          doCancel();
        } else {
          $ctx.showError(
            `Para cancelar este acesso, é necessário cancelar a fatura ${$ctx.subscription.order_id} no gateway ${$ctx.subscription.gateway}.`
          );
        }
      }
    },

    showClient(client_id) {
      window.open("/client/" + client_id);
    },

    showProposal(assistant_id, project_id) {
      window.open("/proposta/" + assistant_id + "/" + project_id);
    },

    formatAddress(address, number, complement, neighborhood) {
      let addr = `${address}, ${number}`;
      if (!StringUtils.isEmpty(complement)) {
        addr += ` - ${complement}`;
      }
      addr += `, ${neighborhood}`;
      return addr;
    },

    formatCPFCNPJ(cpf_cnpj) {
      if (cpf_cnpj.length <= 11) {
        return cpf_cnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
      } else {
        return cpf_cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
      }
    },

    formatPhone(phoneNumber, format) {
      if (format === undefined || format === null) {
        format = intlTelInputUtils.numberFormat.INTERNATIONAL;
      }
      return intlTelInputUtils.formatNumber(phoneNumber, null, format);
    },

    formatProfileValue(key, value) {
      if (typeof value !== "string") {
        return value;
      }

      value = value.replaceAll("-", " ");
      if (key === "flow") {
        switch (value) {
          case "explore":
            return "Descobrindo profissão";
            case "build":
            case "build v2":
            return "Começando carreira";
          case "growth":
            return "Ja atua na área";
        }
      }
      return value;
    },
  },
};
</script>
